import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner, faCheck } from '@fortawesome/pro-light-svg-icons';

const UpdateCell = ({ children, user, fieldName, className, onClick }) => {
  const isUpdating = user._updating === fieldName;
  const isSuccess = user._updateSuccess === fieldName;

  return (
    <div onClick={onClick} className={`cell ${className} update-cell`}>
      <span className='cell-value'>{children}</span>
      {isUpdating && <FontAwesomeIcon icon={faSpinner} className='updating-spinner' spin />}
      {isSuccess && <FontAwesomeIcon icon={faCheck} className='success-check' />}
    </div>
  );
};

UpdateCell.propTypes = {
  children: PropTypes.node.isRequired,
  user: PropTypes.object.isRequired,
  fieldName: PropTypes.string.isRequired,
  className: PropTypes.string,
  onClick: PropTypes.func.isRequired
};

export default UpdateCell;
